export function initials(alt?: string): string | null {
  if (!alt) return null
  const [first = '', second = ''] = alt.trim().split(' ')
  return `${first[0] || ''}${second[0] || ''}` || null
}
